import { LoadState } from "../../constants/enums";
import { IUserDocument, IUserDocumentState } from "./userDocument.types";

export const defaultUserDocument: IUserDocument = {
	// user_attachments_unique_id: 0,
	user_attachments_uuid: "",
	user_uuid: "",
	description: "",
	attachments: [],
	company_outlet_uuid: "",
	status: "ACTIVE",
	created_by_uuid: "",
	created_by_name: "",
	modified_by_uuid: "",
	modified_by_name: "",
	create_ts: "",
	insert_ts: "",
};

export const defaultUserDocumentState: IUserDocumentState = {
	list: {
		data: [],
		totalRecords: 0,
		loading: LoadState.NotLoaded,
		error: null,
	},
	document: {
		data: defaultUserDocument,
		loading: LoadState.NotLoaded,
		error: null,
	},
};
